import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { store } from "store";
import axios from "axios";
var AboutKKView = /** @class */ (function (_super) {
    tslib_1.__extends(AboutKKView, _super);
    function AboutKKView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = store;
        _this.description = "";
        return _this;
    }
    AboutKKView.prototype.routed = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var aboutKK;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        store.page.showTopNav = true;
                        return [4 /*yield*/, axios.get("applicationsettings/description", { params: { locale: this.$i18n.locale } })];
                    case 1:
                        aboutKK = (_a.sent()).data;
                        this.description = aboutKK.description;
                        store.page.title = aboutKK.title;
                        return [2 /*return*/];
                }
            });
        });
    };
    AboutKKView.prototype.signUp = function () {
    };
    AboutKKView = tslib_1.__decorate([
        Component
    ], AboutKKView);
    return AboutKKView;
}(Vue));
export default AboutKKView;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/views/AboutKKView.vue
// module id = 54
// module chunks = 0